import { render, staticRenderFns } from "./orderApproveEdit.vue?vue&type=template&id=24668826&scoped=true"
import script from "./orderApproveEdit.vue?vue&type=script&lang=js"
export * from "./orderApproveEdit.vue?vue&type=script&lang=js"
import style0 from "./orderApproveEdit.vue?vue&type=style&index=0&id=24668826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24668826",
  null
  
)

export default component.exports